import {
  ChangeEventHandler,
  forwardRef,
  type InputHTMLAttributes,
} from 'react';
import cx from 'clsx';
import React from 'react';

export type RadioButtonProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> & {
  onChange?:
    | React.ChangeEventHandler<HTMLInputElement>
    | React.MouseEventHandler<HTMLDivElement>;
};

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, ...props }, ref) => {
    const radioClasses = {
      base: 'peer inline-flex items-center justify-center shrink-0 h-10 w-10 rounded-[50%] bg-ui-form-background border border-solid border-ui-border appearance-none',
      afterElement:
        "after:bg-text-body after:hidden after:h-6 after:w-6 after:content-[''] after:rounded-[50%]",
      states:
        'outline-ui-border outline-offset-0 outline-2 checked:after:block disabled:cursor-not-allowed disabled:opacity-50 focus:outline',
    };

    return (
      <input
        {...props}
        ref={ref}
        type="radio"
        checked={props.checked}
        className={cx(
          radioClasses.base,
          radioClasses.afterElement,
          radioClasses.states,
        )}
        onChange={props.onChange as ChangeEventHandler<HTMLInputElement>}
        data-testid={props.id}
      />
    );
  },
);

RadioButton.displayName = 'RadioButton';
